import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HeaderService } from '../header.service';
import Swal from 'sweetalert2';

import RoutesserviceService from '../routesservice.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AddService {
  imagePath: any;
  private _location: any;

  constructor(
    private router: Router,
    private httpClient: HttpClient,
    private Customeroutes: RoutesserviceService,
    private HeaderService: HeaderService

  ) { }

  // submit employee add form
  async getAdd(

    user_id: any,
    first_name: any,
    last_name: any,
    email: any,
    password: any,
    joining_date: any,
    dob: any,
    department: any,
    phone_number: any,
    cnic: any,
    gender: any,
    about: any,
    profile_image: any,
    user_image: any,
    organization: any,
    designation: any,
    employee_type: any,
    employee_status: any,
    employee_role: any,
    status: any,
    salary_type: any,
    salary: any,
    monthySalaryTax: any,
    ac_number: any,
    multiple_punch: any,
    card_name: any,
    device_id: any,
    open_salary: any,
    address1: any,
    address_lat:any,
    address_lng:any,
    address2: any,
    city: any,
    state: any,
    postal_code: any,
    country: any,
    user_roles: any,
    attandance_type: any,
    sub_department: any,
    total_leaves: any,
    shiftDetails: any,
    userRole_id: any
  ) {

    /**
     *
     * Make Form data
     *
     */
    const formData = {
      user_id: user_id,
      first_name: first_name ?? '',
      last_name: last_name ?? '',
      email: email ?? '',
      password: password ?? '',
      joining_date: joining_date ?? '',
      dob: dob,
      department: department ?? '',
      phone_number: phone_number ?? '',
      cnic: cnic ?? '',
      gender: gender,
      description: about,
      profile_image: profile_image ?? '',
      user_image: user_image ?? '',
      organization_id: Number.parseInt(organization) ?? '',
      designation_id: Number.parseInt(designation) ?? '',
      employee_type: employee_type ?? '',
      employee_status: employee_status ?? '',
      employee_role_id: employee_role ?? '',
      salary_type: salary_type ?? '',
      basic_salary: salary,
      monthly_tax_amount: "" + monthySalaryTax,
      ac_number: ac_number ?? '',
      multiple_punch: multiple_punch ?? '',
      card_name: card_name ?? '',
      device_id: device_id ?? '',
      open_salary: open_salary ?? '',
      address1: address1 ?? '',
      address_lat: address_lat ?? '',
      address_lng: address_lng ?? '',
      address2: address2 ?? '',
      city: city ?? '',
      state: state ?? '',
      postal_code: postal_code ?? '',
      country: country ?? '',
      status: employee_status ?? '',
      user_roles: user_roles ?? '',
      attandance_type: attandance_type ?? '',
      sub_department: sub_department ?? '',
      total_leaves: total_leaves ?? '',
      shiftDetails: shiftDetails,
      user_role_id: userRole_id ?? ''
    };

    const httpFormDataOptions = new HttpHeaders();
    return this.httpClient
      .post(this.Customeroutes.getAdd(), formData, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {

          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
          // this.showSpinner=false;
        }
        return data;
      });
  }

  // update data
  // submit employee add form
  async getUpdate(
    id: any,
    uuid: any,
    address_uuid: any,
    user_id: any,
    first_name: any,
    last_name: any,
    email: any,
    password: any,
    joining_date: any,
    dob: any,
    department: any,
    phone_number: any,
    cnic: any,
    gender: any,
    about: any,
    profile_image: any,
    user_image: any,
    organization: any,
    designation: any,
    employee_type: any,
    employee_status: any,
    employee_role: any,
    status: any,
    salary_type: any,
    salary: any,
    monthySalaryTax: any,
    ac_number: any,
    multiple_punch: any,
    card_name: any,
    device_id: any,
    open_salary: any,
    address1: any,
    address_lat:any,
    address_lng:any,
    address2: any,
    city: any,
    state: any,
    postal_code: any,
    country: any,
    user_roles: any,
    attandance_type: any,
    sub_department: any,
    total_leaves: any,
    shiftDetails: any,
    user_shiftStarttime: any,
    user_shiftendtime: any,
    total_working_hours: any,
    userRole_id: any
  ) {

    /**
     *
     * Make Form data
     *
     */

    const formData = {
      id: id,
      uuid: uuid,
      address_uuid: address_uuid,
      user_id: user_id,
      first_name: first_name ?? '',
      last_name: last_name ?? '',
      email: email ?? '',
      password: password ?? '',
      joining_date: joining_date ?? '',
      dob: dob ?? '',
      department: department ?? '',
      phone_number: phone_number ?? '',
      cnic: cnic ?? '',
      gender: gender?? '',
      description: about ?? '',
      profile_image: profile_image ?? '',
      user_image: user_image ?? '',
      organization_id: Number.parseInt(organization) ?? '',
      designation_id: Number.parseInt(designation) ?? '',
      employee_type: employee_type ?? '',
      employee_status: employee_status ?? '',
      employee_role_id: employee_role ?? '',
      salary_type: salary_type ?? '',
      basic_salary: salary,
      monthly_tax_amount: "" + monthySalaryTax,
      ac_number: ac_number ?? '',
      multiple_punch: multiple_punch ?? '',
      card_name: card_name ?? '',
      device_id: device_id ?? '',
      open_salary: open_salary ?? '',
      address1: address1 ?? '',
      address_lat: address_lat ?? '',
      address_lng: address_lng ?? '',
      address2: address2 ?? '',
      city: city ?? '',
      state: state ?? '',
      postal_code: postal_code ?? '',
      country: country ?? '',
      status: employee_status ?? '',
      user_roles: user_roles ?? '',
      attandance_type: attandance_type ?? '',
      sub_department: sub_department ?? '',
      total_leaves: total_leaves ?? '',
      shiftDetails: shiftDetails ,
      shift_start_time: user_shiftStarttime ?? '',
      shift_end_time: user_shiftendtime ?? '',
      total_working_hours: total_working_hours ?? '',
      user_role_id: userRole_id ?? ''
    };
    const httpFormDataOptions = new HttpHeaders();
    return this.httpClient
      .post(this.Customeroutes.getAdd(), formData, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {

          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
          // this.showSpinner=false;
        }
        return data;
      });
  }

  async getStaticData() {
    return this.httpClient
      .get(this.Customeroutes.getStaticData(), {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data) {
          if (data.success == true) {

            //if login is true the store it into local storage
            // localStorage.setItem('token', data.data.token);
            return data;
            // this.showSpinner=false;
          }
        }
        return data;
      });
  }




  async getmodifidate() {
    const httpFormDataOptions = new HttpHeaders();
    return this.httpClient
      .post(this.Customeroutes.leaveModifiDate(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {

          if (data.success == true) {

            return data;
          }
        }
        return data;
      })
  }



  async deleteUser(udid: string) {
    return this.httpClient
      .get(this.Customeroutes.userDelete(udid), {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),

      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }



  async retrivedUser(udid: string) {
    return this.httpClient
      .get(this.Customeroutes.userRetrived(udid), {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),

      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }



  async updateUser(uuid: string) {
    // alert(uuid)
    return this.httpClient
      .get(this.Customeroutes.userUpdate(uuid), {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),

      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      });
  }


  async teamLead(department: any) {

    return this.httpClient
      .get(this.Customeroutes.teamLeadData(department), {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),

      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      });
  }



  async updatePassword(
    uuid: any,
    password: any,
  ) {

    const statusData = {
      uuid: uuid,
      password: password,
    };
    const httpFormDataOptions = new HttpHeaders();
    return this.httpClient
      .post(this.Customeroutes.getChangepassword(), statusData, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }

  async updateStatus(
    uuid: any,
    employee_status: any,
  ) {

    const statusData = {
      uuid: uuid,
      employee_status: employee_status,
    };
    const httpFormDataOptions = new HttpHeaders();
    return this.httpClient
      .post(this.Customeroutes.getChangeStatus(), statusData, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }



  async updateShiftTime(
    uuid: any,
    startTime: any,
    endTime: any) {
    const shiftupdate = {
      uuid: uuid,
      shift_start_time: startTime,
      shift_end_time: endTime
    };
    const httpFormDataOptions = new HttpHeaders();
    return this.httpClient
      .post(this.Customeroutes.getChangeShiftTime(), shiftupdate, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }

  async updateAccountNo(
    uuid: any, accountNo: any
  ) {
    const accountupdate = {
      uuid: uuid,
      ac_number: accountNo,
    };
    const httpFormDataOptions = new HttpHeaders();
    return this.httpClient
      .post(this.Customeroutes.getChangeAccountNo(), accountupdate, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }

  async updateSalary(
    uuid: any, salary: any, taxSalary: any
  ) {
    const salaryupdate = {
      uuid: uuid,
      basic_salary: salary,
      monthly_tax_amount: taxSalary

    };
    const httpFormDataOptions = new HttpHeaders();
    return this.httpClient
      .post(this.Customeroutes.getChangeSalary(), salaryupdate, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          return data;
        }
        return data;
      });
  }


  async addLoan(
    uuid: any,
    loanAmountValue: any,
    loanDate: any,
    selectedDuration: any,
    InstallmentAmount: any,
    loanPurpose: any,
    profile_image: any,
    loan_file: any

  ) {
    const loanRequest = {
      uuid: uuid,
      loan_amount: loanAmountValue,
      loan_date: loanDate,
      loan_duration: selectedDuration,
      installment: InstallmentAmount,
      loan_reason: loanPurpose,
      profile_image: profile_image,
      loan_file: loan_file
    };

    const httpFormDataOptions = new HttpHeaders();

    return this.httpClient
      .post(this.Customeroutes.getLoanRequest(), loanRequest, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data.success == true) {
          Swal.fire({
            iconHtml: '<img src="../../../../assets/images/success-modal.svg"  alt="image" >',
            title: 'Loan Request Submitted Successfully',
            showConfirmButton: false,
            timer: 3000,
          });
          location.reload();

        } else {
          Swal.fire({
            iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
            title: 'Some Errors In Loan Request',
            showConfirmButton: false,
            timer: 3000,
          });
        }
      });
  }



  async getLoans() {

    return this.httpClient
      .get(this.Customeroutes.getLoanData(), {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),

      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      });
  }


  async getLoanApprove(loan_id: any, action: string
  ) {

    const loanStatus = {
      loan_id: loan_id,
      status: action,
    };

    const httpFormDataOptions = new HttpHeaders();

    return this.httpClient
      .post(this.Customeroutes.loanApproved(), loanStatus, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        return data
      });
  }

  async allAttendance() {

    return this.httpClient
      .get(this.Customeroutes.userAttendance(), {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),

      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      });
  }


  async userAttendanceDetail() {
    const httpFormDataOptions = new HttpHeaders();

    return this.httpClient
      .post(this.Customeroutes.attendanceDetail(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        return data

      });
  }


  async updateAttendance(attendance: any) {
    const httpFormDataOptions = new HttpHeaders();

    return this.httpClient
      .post(this.Customeroutes.getUpateAttendance(), attendance, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        return data;
      });

  }



  async updateBulkAttendance(payload: any) {
    const httpFormDataOptions = new HttpHeaders();

    return this.httpClient
      .post(this.Customeroutes.getBulkUpdateAttendance(), payload, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        return data;
      });

  }



  // Attendance filter

  async getfilter(
    name: any,
    formattedStartDate: any,
    formattedEndDate: any,
    type: any,
    status: any,
    month: any
  ) {

    const userGetName = {
      name: name,
      start_date: formattedStartDate,
      end_date: formattedEndDate,
      type: type,
      status: status,
      monthFilter: month,
    };

    return this.httpClient
      .post(this.Customeroutes.getFilterByName(), userGetName, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {

          return data;
          // this.showSpinner=false;
        }
        return data;
      });

  }










  async filterUserAttendance(id: any, date: any) {
    const attendanceDetail = {
      user_id: id,
      date: date
    };
    return this.httpClient
      .post(this.Customeroutes.getFilterByDate(), attendanceDetail, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data.success == true) {
          //if login is true the store it into local storage
          // localStorage.setItem('token', data.data.token);
          return data;
          // this.showSpinner=false;
        }
        return data;
      });

  }





  async getrequest() {
    return this.httpClient
      .get(this.Customeroutes.getAttndancerequest(), {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),

      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      });

  }


  async getapprove(
    id: any,
    attendance_id: any,
    check_in: any,
    check_out: any,
    working_hours: any,
    overtime: any,
    status: any,
    mytype: any,
    admin_id: any,
    reason: any,

  ) {
    const approveDetail = {
      id: id,
      attendance_id: attendance_id,
      check_in: check_in,
      check_out: check_out,
      working_hours: working_hours,
      overtime: overtime,
      status: status,
      type: mytype,
      admin_id: admin_id,
      reason: reason,

    };
    return this.httpClient
      .post(this.Customeroutes.getapprove(), approveDetail, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data.success == true) {
          Swal.fire({
            iconHtml: '<img src="../../../../assets/images/success-modal.svg"  alt="image" >',
            title: 'Attendece Updated Successfully',
            showConfirmButton: false,
            timer: 3000,
          });
          // location.reload();

        } else {
          Swal.fire({
            iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
            title: 'Some Errors In Attendece Update Request',
            showConfirmButton: false,
            timer: 3000,
          });
        }

        return data;
      });

  }


  // Loan Detail

  getLoanReq(id: any) {

    return this.httpClient
      .get(this.Customeroutes.getLoanDetail(id), {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),

      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      });

  }




  async loanFilter(
    name: any,

  ) {
    const LoanReq = {
      first_name: name,

    };

    return this.httpClient
      .post(this.Customeroutes.filterReq(), LoanReq, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      })

  }



  async showNotify(
    count: any,
  ) {
    const notifyReq = {
      notification_type: count,

    };

    return this.httpClient
      .post(this.Customeroutes.showNotify(), notifyReq, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      })

  }


  async loanNotify(
    lonecount: any,
  ) {
    const loannotifyReq = {
      notification_type: lonecount,

    };

    return this.httpClient
      .post(this.Customeroutes.showNotify(), loannotifyReq, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      })

  }




  async attendanceNotify(
    lattendancecount: any,
  ) {
    const attendancenotifyReq = {
      notification_type: lattendancecount,

    };

    return this.httpClient
      .post(this.Customeroutes.showNotify(), attendancenotifyReq, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      })

  }



  async addEvent(
    event_id: any,
    event_image: any,
    event_name: any,
    event_date: any,
    event_location: any,
    event_type: any,
    event_detail: any,

  ) {
    const eventRequest = {
      event_id: event_id,
      event_image: event_image,
      event_name: event_name,
      event_date: event_date,
      event_location: event_location,
      event_type: event_type,
      event_description: event_detail,
    };

    const httpFormDataOptions = new HttpHeaders();

    return this.httpClient
      .post(this.Customeroutes.geteventRequest(), eventRequest, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data.success == true) {
          Swal.fire({
            iconHtml: '<img src="../../../../assets/images/success-modal.svg"  alt="image" >',
            title: 'Your Request Done Successfully',
            showConfirmButton: false,
            timer: 3000,
          });
          location.reload();

        } else {
          Swal.fire({
            iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
            title: 'Some Errors In Making event',
            showConfirmButton: false,
            timer: 3000,
          });
        }
      });
  }







  async showEventDetail(

    data_type: any,
  ) {
    const data = {
      data_type: data_type,

    };

    const httpFormDataOptions = new HttpHeaders();

    return this.httpClient
      .post(this.Customeroutes.showEvents(), data, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      })
  }





  async deleteEvent(

    selected_id: any,
  ) {

    const event_id = {
      id: selected_id,

    };

    const httpFormDataOptions = new HttpHeaders();

    return this.httpClient
      .post(this.Customeroutes.deleteEvents(), event_id, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data.success == true) {
          Swal.fire({
            iconHtml: '<img src="../../../assets/images/success-modal.svg"  alt="image" >',
            title: 'Event Deleted Successfully',
            showConfirmButton: false,
            timer: 3000,
          });
          location.reload();

        } else {
          Swal.fire({
            iconHtml: ' <img src="../../../assets/images/error-modal.svg"  alt="image" >',
            title: 'Some Errors',
            showConfirmButton: false,
            timer: 3000,
          });
        }
      });
  }

  async eventDetail(

    id: any,
  ) {
    const data = {
      id: id,

    };

    const httpFormDataOptions = new HttpHeaders();

    return this.httpClient
      .post(this.Customeroutes.showEventDetail(), data, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      })
  }





  async selectedaprove(
    ids: any, reason: any, adminid: any,
  ) {
    const data = {
      id: ids,
      reason: reason,
      admin_id: adminid,
    };
    const httpFormDataOptions = new HttpHeaders();
    return this.httpClient
      .post(this.Customeroutes.aproveselecteddata(), data, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {
          Swal.fire({
            iconHtml: '<img src="../../../../assets/images/success-modal.svg"  alt="image" >',
            title: 'All Selected Request Approved Successfully',
            showConfirmButton: false,
            timer: 3000,
          });
          location.reload();
        } else {
          Swal.fire({
            iconHtml: ' <img src="../../../../assets/images/error-modal.svg"   alt="image" >',
            title: 'Some Errors',
            showConfirmButton: false,
            timer: 3000,
          });
        }
      })
  }





  async selectedreject(

    ids: any, reason: any, adminid: any,
  ) {

    const data = {
      id: ids,
      reason: reason,
      admin_id: adminid,
    };

    const httpFormDataOptions = new HttpHeaders();

    return this.httpClient
      .post(this.Customeroutes.rejectselecteddata(), data, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data.success == true) {
          Swal.fire({
            iconHtml: '<img src="../../../../assets/images/success-modal.svg"  alt="image" >',
            title: data.message,
            showConfirmButton: false,
            timer: 3000,
          });
          location.reload();

        } else {
          Swal.fire({
            iconHtml: ' <img src="../../../../assets/images/error-modal.svg"   alt="image" >',
            title: data.message,
            showConfirmButton: false,
            timer: 3000,
          });
        }
      })
  }



  async() {

    const httpFormDataOptions = new HttpHeaders();

    return this.httpClient
      .post(this.Customeroutes.approveallReq(), {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data.success == true) {
          Swal.fire({
            iconHtml: '<img src="../../../../assets/images/success-modal.svg"  alt="image" >',
            title: 'All Selected Request Rejected Successfully',
            showConfirmButton: false,
            timer: 3000,
          });
          location.reload();

        } else {
          Swal.fire({
            iconHtml: ' <img src="../../../../assets/images/error-modal.svg"   alt="image" >',
            title: 'Some Errors',
            showConfirmButton: false,
            timer: 3000,
          });
        }
      })
  }


  async allApprove(
    adminid: any,
    reason: any,
    filtername: any,
    formattedStartDate: any,
    formattedEndDate: any,
    filtertype: any,
    filterstatus: any,
    filtermonth: any,
  ) {
    const value = {
      admin_id: adminid,
      reason: reason,
      filtername: filtername,
      formattedStartDate: formattedStartDate,
      formattedEndDate: formattedEndDate,
      filtertype: filtertype,
      filterstatus: filterstatus,
      filtermonth: filtermonth,
    };
    const httpFormDataOptions = new HttpHeaders();

    return this.httpClient
      .post(this.Customeroutes.approveallReq(), value, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data.success == true) {
          Swal.fire({
            iconHtml: '<img src="../../../../assets/images/success-modal.svg"  alt="image" >',
            title: 'All Request Approved Successfully',
            showConfirmButton: false,
            timer: 3000,
          });
          location.reload();

        } else {
          Swal.fire({
            iconHtml: ' <img src="../../../../assets/images/error-modal.svg"   alt="image" >',
            title: 'Some Errors',
            showConfirmButton: false,
            timer: 3000,
          });
        }
      })
  }



  async allReject(
    adminid: any,
    reason: any,
    filtername: any,
    formattedStartDate: any,
    formattedEndDate: any,
    filtertype: any,
    filterstatus: any,
    filtermonth: any,
  ) {
    const value = {
      admin_id: adminid,
      reason: reason,
      filtername: filtername,
      formattedStartDate: formattedStartDate,
      formattedEndDate: formattedEndDate,
      filtertype: filtertype,
      filterstatus: filterstatus,
      filtermonth: filtermonth,
    };
    const httpFormDataOptions = new HttpHeaders();

    return this.httpClient
      .post(this.Customeroutes.rejectallReq(), value, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data.success == true) {
          Swal.fire({
            iconHtml: '<img src="../../../../assets/images/success-modal.svg"  alt="image" >',
            title: 'All Request Rejected Successfully',
            showConfirmButton: false,
            timer: 3000,
          });
          location.reload();

        } else {
          Swal.fire({
            iconHtml: ' <img src="../../../../assets/images/error-modal.svg"   alt="image" >',
            title: 'Some Errors',
            showConfirmButton: false,
            timer: 3000,
          });
        }
      })
  }





  async modeColor(

    mode: any,
  ) {

    const data = {
      color_mode: mode,

    };

    const httpFormDataOptions = new HttpHeaders();

    return this.httpClient
      .post(this.Customeroutes.modeColor(), data, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      })
  }





  async getuserdetail() {

    return this.httpClient
      .get(this.Customeroutes.userdetail(), {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),

      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      });
  }

  async attendanceset() {
    const httpFormDataOptions = new HttpHeaders();
    return this.httpClient
      .post(this.Customeroutes.setattendance(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {

          if (data.success == true) {

            return data;
          }
        }
        return data;
      })
  }




  async settodayattendance() {
    const httpFormDataOptions = new HttpHeaders();
    return this.httpClient
      .post(this.Customeroutes.settodayattendance(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {

          if (data.success == true) {

            return data;
          }
        }
        return data;
      })
  }




  async getCardsimages() {
    const httpFormDataOptions = new HttpHeaders();
    return this.httpClient
      .post(this.Customeroutes.cardsImages(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {

          if (data.success == true) {

            return data;
          }
        }
        return data;
      })
  }



  async addUserrole(
    role_name: any,
    roleType: any,
    user_roles: any,
    isActive: any,
    department_id:any
  ) {
    const data = {
      role_name: role_name,
      role_type: roleType,
      user_roles: user_roles,
      is_active: isActive,
       department_id:department_id
    };
    const httpFormDataOptions = new HttpHeaders();
    return this.httpClient
      .post(this.Customeroutes.addRole(), data, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      })
  }



  async updateUserrole(
    role_name: any,
    roleType: any,
    user_roles: any,
    isActive: any,
    department_id:any,
    id: any


  ) {
    const data = {
      role_name: role_name,
      role_type: roleType,
      user_roles: user_roles,
      is_active: isActive,
      department_id:department_id,
      id: id
    };
    const httpFormDataOptions = new HttpHeaders();
    return this.httpClient
      .post(this.Customeroutes.addRole(), data, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      })
  }


  async leaveNotify() {

    return this.httpClient
      .get(this.Customeroutes.leaveNotify(), {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),

      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {
          if (data.success == true) {

            return data;
          }
        }
        return data;
      });
  }




  async getAttendanceId() {
    const httpFormDataOptions = new HttpHeaders();
    return this.httpClient
      .post(this.Customeroutes.getAttendanceId(), '', {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {

          if (data.success == true) {

            return data;
          }
        }
        return data;
      })
  }



  async userComingSalary(id: any,) {
    const data = {
      id: id,
    };
    const httpFormDataOptions = new HttpHeaders();
    return this.httpClient
      .post(this.Customeroutes.upcomingSalary(), data, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {

          if (data.success == true) {

            return data;
          }
        }
        return data;
      })
  }







async updateUserImage(Profile_img: any,) {
    const data = {
      profile_image: Profile_img,
    };
    const httpFormDataOptions = new HttpHeaders();
    return this.httpClient
      .post(this.Customeroutes.updateProfileImage(), data, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {

        if (data) {

          if (data.success == true) {

            return data;
          }
        }
        return data;
      })
  }



  


}
